// hooks/useOrigens.ts
import { useState, useEffect } from 'react';
import { apiService } from '../services/api';
import { Origem } from '../types/origens';

export const useOrigens = () => {
    const [origens, setOrigens] = useState<Origem[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchOrigens = async () => {
        try {
            setLoading(true);
            const response = await apiService.getOrigens();
            setOrigens(response.data);
            setError(null);
        } catch (err) {
            setError('Erro ao carregar origens. Por favor, tente novamente.');
            console.error('Erro ao buscar origens:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOrigens();
    }, []);

    return {
        origens,
        loading,
        error,
        refetchOrigens: fetchOrigens
    };
};